import { IDemo, E3DDemoNameVals, DemoIds } from 'types'
import { getSharedAsset } from '../../helpers/utils'

const video = getSharedAsset('ice-mobility.mp4', 'demos', 'videos')
const poster = getSharedAsset('ice-mobility.png', 'demos', 'posters')
const monolith = getSharedAsset('ice-mobility.png', 'demos', 'monoliths')
const nextDemoThumbnail = getSharedAsset('jigspace.png', 'demos', 'thumbnails')

export const iceMobility: IDemo = {
  id: DemoIds.iceMobility,
  type: E3DDemoNameVals.iceMobility,
  video,
  monolith,
  poster,
  end: {
    header: 'Automating quality control processes.',
    body: 'Improving quality control processes through computer vision, removing steps and increasing accuracy.',
    nextDemoText: 'Streamline prototyping using AR.',
    nextDemo: E3DDemoNameVals.jigspace,
    nextDemoId: DemoIds.jigspace,
    nextDemoThumbnail,
    previousDemoId: DemoIds.mecExplainer
  }
}
